import { mergeStyleSets } from '@uifabric/merge-styles';

export default mergeStyleSets({
  pickerField: {
    '.ms-Callout': {
      zIndex: 1,
    },
  },
});
